import React from 'react'
import { JobsSection, JobsContainer, JobsHeading } from './styles'

const JobsHero = () => {
  return (
    <JobsSection>
      <JobsContainer>
        <JobsHeading>Job Board</JobsHeading>
      </JobsContainer>
    </JobsSection>
  )
}

export default JobsHero
